<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>

    <div class="relative">
      <input 
        :type="type" 
        :id="id" 
        ref="input" 
        v-bind="{ ...$attrs, class: null }" 
        class="form-input" 
        :class="{ error: error }" 
        :value="dateValue"
        v-model="dateValue"
        v-mask="'##/##/####'" />

        <button 
          type="button" 
          class="absolute right-0" 
          @click.prevent="$e => this.$refs.datepicker.openMenu()">
            <font-awesome-icon icon="fa-regular fa-calendar" />
        </button>
    </div>

    <Datepicker 
      ref="datepicker"
      v-model="dateValue" 
      modelType="dd/MM/yyyy" 
      weekStart="0" 
      autoApply
      :class="{ error: error }" 
      :enableTimePicker="false" 
      locale="pt-BR"
      :clearable="false">
        <template #dp-input="{ value, onInput, onEnter, onTab, onClear }">
        </template>
    </Datepicker>

    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import ptBR from 'date-fns/locale/pt-BR'

import { mask } from 'vue-the-mask'

import { ref, watch } from 'vue'

export default {
  inheritAttrs: false,

  directives: { mask },
  components: { Datepicker, ptBR,  },

  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    modelValue: String,
  },
  emits: ['update:modelValue'],

  setup( props, ctx ) {
    const dateValue = ref( props.modelValue?.replace( /(\d{4})\-(\d{2})\-(\d{2})/, '$3-$2-$1' ) )
    const error = ref( props.error )

    watch( () => props.error, () => error.value = props.error )

    watch( dateValue, () => {
      if ( dateValue.value.length == 10 ) {
        const formatedData = dateValue.value.replace( /(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1' )
        error.value = null

        ctx.emit( 'update:modelValue', formatedData )
      }
    } )

    return {
      dateValue, error,
    }
  },
}
</script>
